/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$tiny-width: 18;
$small-width: 24;
$normal-width: 32;
$big-width: 96;

:host {
  position: relative;
  color: v(color);
  fill: currentColor;
  display: flex;
}
.#{$prefix}icon-wrapper {
  position: relative;
  justify-self: center;
  align-self: center;
  width: 32px;
  height: 32px;
  display: inline-flex;

  &.#{$prefix}size-big {
    width: 96px;
    height: 96px;
    svg {
      -webkit-transform: scale(calc(96 / 32));
      transform: scale(calc(96 / 32));
    }
  }

  &.#{$prefix}size-small {
    width: 24px;
    height: 24px;
    -webkit-transform: scale(0.75, 0.75);
    transform: scale(0.75, 0.75);
  }

  &.#{$prefix}size-tiny {
    width: 18px;
    height: 18px;
    -webkit-transform: scale(0.56, 0.56);
    transform: scale(0.56, 0.56);
  }

  svg {
    display: block; // Included due to a MS Edge (pre-chromium) bug. Icons were displaced inside the button without this.#{$prefix}
    overflow: visible;
  }

  &.#{$prefix}no-spacing.#{$prefix}size-big {
    width: calc(var(--iconWidth) * 96px / 32);
  }

  &.#{$prefix}no-spacing.#{$prefix}size-small {
    width: calc(var(--iconWidth) * 24px / 32);
  }

  &.#{$prefix}no-spacing.#{$prefix}size-tiny {
    width: calc(var(--iconWidth) * 18px / 32);
  }

  &.#{$prefix}x-left {
    justify-content: flex-start;
  }

  &.#{$prefix}x-center {
    justify-content: center;
  }

  &.#{$prefix}x-right {
    justify-content: flex-end;
  }

  &.#{$prefix}y-top {
    align-items: flex-start;
  }

  &.#{$prefix}y-center {
    align-items: center;
  }

  &.#{$prefix}y-bottom {
    align-items: flex-end;
  }

  &.#{$prefix}no-spacing {
    width: auto;
  }

  &.#{$prefix}default-height {
    height: auto;
  }

  &.#{$prefix}x-left.#{$prefix}y-top svg {
    transform-origin: left top;
  }

  &.#{$prefix}x-left.#{$prefix}y-center svg {
    transform-origin: left center;
  }

  &.#{$prefix}x-left.#{$prefix}y-bottom svg {
    transform-origin: left bottom;
  }

  &.#{$prefix}x-center.#{$prefix}y-top svg {
    transform-origin: center top;
  }

  &.#{$prefix}x-center.#{$prefix}y-center svg {
    transform-origin: center center;
  }

  &.#{$prefix}x-center.#{$prefix}y-bottom svg {
    transform-origin: center bottom;
  }

  &.#{$prefix}x-right.#{$prefix}y-top svg {
    transform-origin: right top;
  }

  &.#{$prefix}x-right.#{$prefix}y-center svg {
    transform-origin: right center;
  }

  &.#{$prefix}x-right.#{$prefix}y-bottom svg {
    transform-origin: right bottom;
  }

  &.#{$prefix}context-menu {
    cursor: pointer;
  }

  &.#{$prefix}tooltip-icon {
    &:focus {
      @include focusBorder(v(iconFocusColor), 2px);
    }

    &:focus-within {
      @include focusBorder(v(iconFocusColor), 2px);
    }
  }

  &:focus-visible {
    outline: none;
  }

  &.#{$prefix}visibility-on-click {
    cursor: pointer;
  }
}
